import React, { Fragment } from "react";
import ReactDOM from "react-dom";

/*
  All other functions not customised here in this JS file will be imported from core components
*/
import LoginPage from "components/Login/LoginPage";
import TextInput from "components/shared/Inputs/TextInput";
import Link from "components/shared/Link/Link";

import granny_logo from "images/custom/login/login_graphic.png";
/*
  Import necessary variables used in this JS file - look out for warnings/errors flagged by npm start
*/
import {
  ENABLE_LOGIN_TOPBAR,
  ENABLE_REGISTER_PAGES,
  ENABLE_LOGIN_HOME,
  PRIVACY_PAGE_LINK,
  ENABLE_EMAIL_LOGIN,
  USE_LOGIN_HOME_TEMPLATE_1
} from "config";

import {
  PROJECT_REGISTER,
  REGISTER,
  PROJECT_RESET_PASSWORD,
  RESET_PASSWORD
} from "App/Routes";

import urlServices from "services/urlServices";
import deviceServices from "services/deviceServices";

/*
  If copywriting is involved, multi language support may be needed (or assumed to be needed).
  If it is very clear that multi-langage support is not needed, you may choose to hard code some text for convenience
*/
import localize from "lang/localize";

import "./Login.css";
import { LOGIN_TOUR } from "App/Routes";

class AhmaLoginPage extends LoginPage {
  /**
   * Set page identifier classes
   * (To specifically target this page for styling/customizations)
   */
  componentDidMount() {
    // Set page identifier class to .component-container
    let mainComponent = ReactDOM.findDOMNode(this).parentNode;
    if (!mainComponent.classList.contains("loginPage")) {
      mainComponent.className += " loginPage";
    }

    // Add other page classes to body DOM
    let bodyDOM = document.body; // <body> tag
    if (!bodyDOM.classList.contains("page-not-loggedin")) {
      bodyDOM.className += " page-not-loggedin";
    }

    if (!bodyDOM.classList.contains("loginPageBody")) {
      bodyDOM.className += " loginPageBody";
    }
  }

  /**
   * Remove page identifier classes
   */
  componentWillUnmount() {
    // Remove page identifier class from .component-container
    let mainComponent = ReactDOM.findDOMNode(this).parentNode;
    if (mainComponent.classList.contains("loginPage")) {
      mainComponent.classList.remove("loginPage");
    }

    // Remove other page classes from body DOM
    let bodyDOM = document.body;
    if (bodyDOM.classList.contains("page-not-loggedin")) {
      bodyDOM.classList.remove("page-not-loggedin");
    }

    if (bodyDOM.classList.contains("loginPageBody")) {
      bodyDOM.classList.remove("loginPageBody");
    }
  }

  renderLoginFields() {
    if (ENABLE_EMAIL_LOGIN) {
      return (
        <Fragment>
          {/* <h4>{localize("alert_login_text", this.props.language)}</h4> */}
          <TextInput
            id="emailInput"
            value={this.props.email}
            onChange={this.props.handleEmailChange}
            onKeyPress={this.handleKeyPress}
            placeholder={localize(
              "login_view_email_placeholder_text",
              this.props.language
            )}
          />
          <TextInput
            id="passwordInput"
            type="password"
            value={this.props.password}
            onChange={this.props.handlePasswordChange}
            onKeyPress={this.handleKeyPress}
            placeholder={localize(
              "login_view_password_placeholder_text",
              this.props.language
            )}
          />
          <div className="pure-g bottommargin">
            <div className="pure-u-1-2 flex align-items-center">
              <p className="smalltext nomargin">
                <Link
                  to={
                    this.props.projectId
                      ? PROJECT_RESET_PASSWORD.format(this.props.projectId)
                      : RESET_PASSWORD
                  }
                  className="default"
                >
                  {localize(
                    "login_view_forgetpassword_text",
                    this.props.language
                  )}
                </Link>
              </p>
            </div>
            <div className="pure-u-1-2">
              <button
                id="loginButton"
                className={
                  "button fullwidth" +
                  (!!this.props.isSubmitLoading ? " disabled" : " cta")
                }
                type="submit"
                disabled={!!this.props.isSubmitLoading}
              >
                {!!this.props.isSubmitLoading
                  ? localize(
                      "nav_bar_title_generic_loading",
                      this.props.language
                    )
                  : localize("button_login", this.props.language)}
              </button>
            </div>
          </div>
        </Fragment>
      );
    } else {
      return null;
    }
  }

  renderRegisterSection() {
    if (
      !ENABLE_LOGIN_HOME ||
      (ENABLE_LOGIN_HOME && USE_LOGIN_HOME_TEMPLATE_1)
    ) {
      return (
        <Fragment>
          <br />
          <p className="textcenter nomargin">
            <strong>
              {localize("login_view_register_start", this.props.language) + " "}
            </strong>
          </p>
          <Link
            to={
              this.props.projectId
                ? PROJECT_REGISTER.format(this.props.projectId)
                : REGISTER
            }
            className="default textcenter display-block"
          >
            {localize("login_view_signup_text", this.props.language)}
          </Link>
          <p className="textcenter topmargin">
            <a
              className="default textcenter display-block about-granny"
              href="https://app.gametize.com/topic/47806"
              target="_blank"
              rel="noreferrer"
            >
              <strong>More about LearnGranny</strong>
            </a>
          </p>
        </Fragment>
      );
    } else {
      return null;
    }
  }

  render() {
    if (
      /* checking type is important: showPrivacyAgreement is initialised as null */
      typeof this.props.showPrivacyAgreement === "boolean" &&
      this.props.showPrivacyAgreement === true
    ) {
      return (
        <div className="login-register-container container verticalpadding">
          {this.renderTopbarlessBackButton()}
          <div
            className={
              "innerblock pure-g" +
              (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR ? " topmargin-20" : "")
            }
          >
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
            <div className="pure-u-1 pure-u-sm-16-24 pure-u-md-1-2">
              <h5>
                {localize(
                  "login_view_privacy_policy_updated_title",
                  this.props.language
                )}
              </h5>
              <p>
                {localize("login_agree_to_new_terms_text", this.props.language)}
              </p>
              <div className="bottommargin-30">
                <p className="smalltext">
                  <input
                    type="checkbox"
                    onChange={this.props.handleUpdatePrivacyAgreed}
                    checked={this.props.privacyAgreed}
                  />{" "}
                  {localize(
                    "register_agree_to_gametize_text",
                    this.props.language
                  )}
                  <a
                    className="link default"
                    href={PRIVACY_PAGE_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {localize(
                      "register_privacy_policy_text",
                      this.props.language
                    )}
                  </a>
                  .
                </p>
                <p className="smalltext">
                  <input
                    type="checkbox"
                    onChange={this.props.handleUpdateMarketingConsent}
                    checked={this.props.marketingConsent}
                  />{" "}
                  {localize(
                    "register_marketing_communications_text",
                    this.props.language
                  )}
                </p>
              </div>
              <div className="pure-g bottommargin">
                <div className="pure-u-11-24 pure-u-sm-14-24 pure-u-lg-2-3" />
                <div className="pure-u-13-24 pure-u-sm-10-24 pure-u-lg-1-3">
                  <button
                    className={
                      "button fullwidth " +
                      (this.props.privacyAgreed ? "cta" : "inactive")
                    }
                    onClick={this.props.handlePrivacySubmit}
                    disabled={!this.props.privacyAgreed}
                  >
                    {localize("button_quest_continue", this.props.language)}
                  </button>
                </div>
              </div>
            </div>
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
          </div>
        </div>
      );
    } else {
      return (
        <div className="login-register-container container verticalpadding">
          {this.renderTopbarlessBackButton()}
          <div
            className={
              "innerblock pure-g" +
              (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR ? " topmargin-20" : "")
            }
          >
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
            <div className="pure-u-1 pure-u-sm-16-24 pure-u-md-1-2">
              <div className="flex flex-direction-column align-items-center logo text-align-center">
                <img src={granny_logo} alt=""></img>
                <p>
                  Heard of the legendary granny that can run faster than you?
                  That’s me! With Granny's game-like and story-based learning
                  adventures, you can master business survival skills in a few
                  moves now! <br />
                </p>
                <h5 className="granny-link">
                  <Link to={LOGIN_TOUR}>Quick Tour</Link>
                  &nbsp;|&nbsp;
                  <a
                    href="https://app.gametize.com/topic/49226"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Browse Adventures
                  </a>
                </h5>
              </div>
              <form
                className="pure-form"
                onSubmit={this.handlePreSubmit.bind(this)}
              >
                {this.renderLoginFields()}
                {this.renderGuestLoginSection()}
                {/* Add hidesso=true to query string in order to hide sso login, e.g. /login?hidesso=true */}
                {urlServices.getUrlParamValueByKey("hidesso") !== "true" &&
                  !deviceServices.isWebView() &&
                  this.renderSSOLoginSection()}
                {ENABLE_REGISTER_PAGES && this.renderRegisterSection()}
              </form>
            </div>
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
          </div>
        </div>
      );
    }
  }
}

export default AhmaLoginPage;
